export const excludeSkuFilter = (productSku) => {

  return ` and not(masterData(current(masterVariant(sku="${productSku}"))))`;

};
